import React from "react";
import LightGallery from "lightgallery/react";
import lgZoom from "lightgallery/plugins/zoom";
import lgVideo from "lightgallery/plugins/video";
import lgShare from "lightgallery/plugins/share";
import lgThumbnail from "lightgallery/plugins/thumbnail";

const GiftBoxGallery = () => {
  /*eslint-disable */
  return (
    <section id="gift-box-gallery" className="gallery">
      <h1 className="title">Hộp Quà Tết</h1>
      <LightGallery
        download={false}
        plugins={[lgZoom, lgVideo, lgShare, lgThumbnail]}
        mode="lg-fade"
      >
        {/* An Khang */}
        <a
          className="gallery-item"
          data-src="images/products/gift-box/an khang sp.png"
          data-sub-html="<h1>Tết An Khang</h1><h2>1.450.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-box/an khang.png"
            width="300"
            height="300"
          />
        </a>

        {/* An Yen */}
        <a
          className="gallery-item"
          data-src="images/products/gift-box/an yen sp.png"
          data-sub-html="<h1>Tết An Yên</h1><h2>750.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-box/an yen.png"
            width="300"
            height="300"
          />
        </a>

        {/* Cat Tuong */}
        <a
          className="gallery-item"
          data-src="images/products/gift-box/cat tuong sp.png"
          data-sub-html="<h1>Tết Cát Tường</h1><h2>1.100.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-box/cat tuong.png"
            width="300"
            height="300"
          />
        </a>

        {/* Doan Vien */}
        <a
          className="gallery-item"
          data-src="images/products/gift-box/doan vien sp.jpg"
          data-sub-html="<h1>Tết Đoàn Viên</h1><h2>1.450.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-box/doan vien.png"
            width="300"
            height="300"
          />
        </a>

        {/* Nhu Y */}
        <a
          className="gallery-item"
          data-src="images/products/gift-box/nhu y sp.png"
          data-sub-html="<h1>Tết Như Ý</h1><h2>1.250.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-box/nhu y.png"
            width="300"
            height="300"
          />
        </a>

        {/* Phuc Loc */}
        <a
          className="gallery-item"
          data-src="images/products/gift-box/phuc loc sp.png"
          data-sub-html="<h1>Tết Phúc Lộc</h1><h2>1.000.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-box/phuc loc.png"
            width="300"
            height="300"
          />
        </a>

        {/* Sum Vay */}
        <a
          className="gallery-item"
          data-src="images/products/gift-box/sum vay sp.jpg"
          data-sub-html="<h1>Tết Sum Vầy</h1><h2>1.350.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-box/sum vay.png"
            width="300"
            height="300"
          />
        </a>

        {/* Thinh Vuong */}
        <a
          className="gallery-item"
          data-src="images/products/gift-box/thinh vuong sp.png"
          data-sub-html="<h1>Tết Thịnh Vượng</h1><h2>1.250.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-box/thinh vuong.png"
            width="300"
            height="300"
          />
        </a>

        {/* Binh An */}
        <a
          className="gallery-item"
          data-src="images/products/gift-box/binh an sp.png"
          data-sub-html="<h1>Tết Bình An</h1><h2>1.450.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-box/binh an.png"
            width="300"
            height="300"
          />
        </a>

        {/* Dong Day */}
        <a
          className="gallery-item"
          data-src="images/products/gift-box/dong day sp.png"
          data-sub-html="<h1>Tết Đong Đầy</h1><h2>1.550.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-box/dong day.png"
            width="300"
            height="300"
          />
        </a>

        {/* Thang Hoa */}
        <a
          className="gallery-item"
          data-src="images/products/gift-box/thang hoa sp.png"
          data-sub-html="<h1>Tết Thăng Hoa</h1><h2>1.250.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-box/thang hoa.png"
            width="300"
            height="300"
          />
        </a>
      </LightGallery>
    </section>
  );
};

export default GiftBoxGallery;
